import { Component, OnInit, Signal, signal, ViewChild, ElementRef, OnDestroy, WritableSignal, effect } from "@angular/core"; 
import { Location } from "@angular/common";
import { MessageService, ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Router, ActivatedRoute } from '@angular/router';
import { FournisseurService } from 'src/app/services/fournisseur-service';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { AppMainComponent } from 'src/app/app.main.component';
import { LocationService } from 'src/app/services/location-service';
import { DocumentService } from 'src/app/services/document-service';
import { ContexteService } from 'src/app/services/contexte-service';
import { BaseComponent } from 'src/app/base/base-component';
import { BreadcrumbService } from 'src/app/app.breadcrumb.service';
import { HeureKmService } from 'src/app/services/heure-km-service';
import { MenuItem } from 'primeng/api';
import { LigneHeureKmEntite } from "src/app/entites/mecanique/ligne-heure-km";
import { HeureService } from "src/app/services/heure-service";
import { KmService } from "src/app/services/km-service";
import { Emplacement } from "src/app/entites/emplacement";
import { DepartementMecaniqueEntite } from "src/app/entites/mecanique/departement-mecanique";
import { Table } from "primeng/table";
import { RapportService } from "src/app/services/rapport-service";
@Component({
    templateUrl: './saisie-heures-kms.component.html',
    providers: [MessageService, ConfirmationService, DialogService]
})
export class SaisieHeuresKmsComponent extends BaseComponent implements OnInit, OnDestroy {

    menu: MenuItem[] = [
        {
            label: 'Retour', 
            icon: 'pi pi-fw pi-angle-double-left', 
            disabled: this.modeModification(),
            command: () => window.history.back()
        }
    ];

    tabIndex: Signal<number> = signal(0);

    numeroItemManuelle = this.createParamSignal('numeroItemManuelle', '');
    loading: boolean = false;
    manuelleSubmitted: boolean = false;
    heureKmManuelle: LigneHeureKmEntite;
    dateHeures: Date = new Date();
    dateKms: Date = new Date();
    heures: number;
    kms: number;

    showHeures: WritableSignal<boolean> = signal(true);
    showKms: WritableSignal<boolean> = signal(true);

    listeHeuresKms: LigneHeureKmEntite[] = [];
    listeHeuresKmsFiltree: LigneHeureKmEntite[] = [];

    emplacements: Emplacement[];
    emplacement: WritableSignal<Emplacement> = signal(null);
    departements: DepartementMecaniqueEntite[];
    departement: WritableSignal<DepartementMecaniqueEntite> = signal(null);
    dateListe: WritableSignal<Date> = signal(new Date());
    
    @ViewChild('inputHeures') inputHeures!: ElementRef;
    @ViewChild('inputKms') inputKms!: ElementRef;
    @ViewChild('inputNumero') inputNumero!: ElementRef;
    @ViewChild('dtListe') dtListe!: Table;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute, 
		appMain: AppMainComponent, location: Location, 
        private breadcrumbService: BreadcrumbService,
        private heureKmService: HeureKmService,
        private kmService: KmService,
        private heureService: HeureService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        public routerService: Router,
        private rapportService: RapportService ) {

        super(sdb, profilService, route, routerService, appMain);

        effect(() => {
            console.log(this.departement());
            console.log(this.emplacement());
            console.log(this.showHeures());
            console.log(this.showKms());
            this.listeHeuresKmsFiltree = this.listeHeuresKms.filter(x => 
                (this.departement() ? x.departementId == this.departement().departementMecaniqueId : true) && 
                (this.emplacement() ? x.emplacementId == this.emplacement().emplacementId : true) &&
                (x.indSuiviHeures ? this.showHeures() : true) &&
                (x.indSuiviKms ? this.showKms() : true));
        });

        this.breadcrumbService.setItems([
            { label: 'Saisie des heures et des kms' }
        ]);

    }

    ngOnInit() {
        this.verifierAccesPage('heures_saisie');
        this.initialiserMenu(); 

        this.emplacements = this.sdb.Emplacements();
        this.departements = this.sdb.DepartementsMecanique();

        setTimeout(() => { this.inputNumero.nativeElement.focus(); }, 50);

        this.heureKmService.ObtenirListe().subscribe({
            next: h => {
                this.listeHeuresKms = h;
                this.listeHeuresKmsFiltree = h;
                this.CompleterChargement();
            },
            error: () => {
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Une erreur est survenue lors de la récupération des heures et kms.' });
                this.CompleterChargement();
            }
        });
    }

    ngOnDestroy() {
        this.cleanup();
    }

    initialiserMenu(){
        this.menu = [
            { label: 'Retour', icon: 'pi pi-fw pi-angle-double-left', disabled: this.modeModification(), command: () => window.history.back() }
        ];
    }

    validerNoItem(){
        this.manuelleSubmitted = true;

        if(this.numeroItemManuelle() == '') return;

        this.loading = true;
        this.heureKmService.ObtenirHeuresKmsParItem(this.numeroItemManuelle()).subscribe({
            next: h => {
                this.heureKmManuelle = h;
                setTimeout(() => { this.inputHeures.nativeElement.focus(); }, 50);
                this.loading = false;

            },
            error: () => {
                this.loading = false;
            }
        });
    }

    sauvegarderHeureManuelle(){
        this.heureService.Ajouter({
            employeId: this.profilService.ProfilCourant().employeId,
            lignesHeure: [
                {
                    ...this.heureKmManuelle,
                    heures: this.heures,
                    dateNouvellesHeures: this.dateHeures
                }
            ]
        }).then(res => {
            if (res.estUnSucces) {
                this.heureKmManuelle.indApprouve = true;
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Heures sauvegardées.` });
                setTimeout(() => { this.inputHeures.nativeElement.focus(); }, 50);
            }
            else{
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: res.valeur[0].erreur });
            }
        })
    }

    sauvegarderKmManuelle(){
        this.kmService.Ajouter({
            employeId: this.profilService.ProfilCourant().employeId,
            lignesKm: [
                {
                    ...this.heureKmManuelle,
                    kms: this.kms,
                    dateNouvellesKms: this.dateKms
                }
            ]
        }).then(res => {
            if (res.estUnSucces) {
                this.heureKmManuelle.indKmsApprouve = true;
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `KM sauvegardés.` });
                setTimeout(() => { this.inputKms.nativeElement.focus(); }, 50);
            }
            else{
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: res.valeur[0].erreur });
            }
        })
    }

    sauvegarderListe(){
        this.listeHeuresKmsFiltree.forEach(h => {
            h.dateNouvellesHeures = this.dateListe();
            h.erreur = null;
        });

        var listeEnvoi = [];
        if(this.showHeures()){
            listeEnvoi.push(...this.listeHeuresKmsFiltree.filter(x => x.heures));
        }
        if(this.showKms()){
            listeEnvoi.push(...this.listeHeuresKmsFiltree.filter(x => x.kms));
        }

        this.heureKmService.Ajouter({
            employeId: this.profilService.ProfilCourant().employeId,
            lignesHeureKm: listeEnvoi
        }).then(res => {
            if (res.estUnSucces) {
                this.listeHeuresKmsFiltree.forEach(h => {
                    if(this.showHeures()){
                        if (h.heures) {
                            h.indApprouve = true;
                        }
                        h.heures = null;
                    }
                    if(this.showKms()){
                        if (h.kms) {
                            h.indKmsApprouve = true;
                        }
                        h.kms = null;
                    }
                });
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Heures sauvegardées.` });
                setTimeout(() => { this.inputNumero.nativeElement.focus(); }, 50);
            }
            else{
                res.valeur.forEach(l => {
                    if (l.erreur) {
                        var ligneAMettreEnErreur = this.listeHeuresKms.find(x => x.itemId == l.itemId);
                        ligneAMettreEnErreur.erreur = l.erreur;
                    }
                });
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Des erreurs empêchent la sauvegarde des heures.' });
            }
        })
    }

    exporter(){
        this.messageService.add({ severity: 'info', summary: 'Info', detail: 'En cours de génération...' });
        this.rapportService.ProduireRapportSaisieHeures(this.emplacement()?.emplacementId, this.departement()?.departementMecaniqueId, this.showHeures(), this.showKms()).then(res => {
            if (res) {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Rapport généré avec succès.' });
            }
            else{
                this.messageService.add({ severity: 'error', summary: 'Erreur', detail: 'Erreur lors de la génération du rapport.' });
            }
        });
    }

    afficherUnite(itemId: string){
        var hasModifications = this.listeHeuresKmsFiltree.find(h => {
            if(this.showHeures() && h.heures){
                return true;
            }
            if(this.showKms() && h.kms){
                return true;
            }
            return false;
        });

        if(hasModifications){
            this.confirmationService.confirm({
                message: 'Vous aller perdre la saisie en cours. Voulez-vous continuer ?',
                accept: () => {
                this.routerService.navigate(['item', itemId]);
            },
            reject: () => {
                    // Do nothing
                }
            });
        }
        else{
            this.routerService.navigate(['item', itemId]);
        }
    }
    
    annuler(){
        this.heureKmManuelle = null;
        this.numeroItemManuelle.set('');
        this.manuelleSubmitted = false;
        setTimeout(() => { this.inputNumero.nativeElement.focus(); }, 50);
    }

    retirerFiltres(){
        this.emplacement.set(null);
        this.departement.set(null);
        this.listeHeuresKmsFiltree = this.listeHeuresKms;
    }
}
